var divElem = document.getElementById("a11yform");
if(divElem!=null){
    var inputElements = divElem.querySelectorAll("input, select, textarea");

    for(let i = 0; i < inputElements.length; i++){
        inputElements[i].setAttribute('tabindex', '-1');
    }
}